import Component from 'gia/Component';
import Splide from '@splidejs/splide';
import gsap from 'gsap';

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.links = this.DOM.view.querySelectorAll('.js-link')

    //! Fns
    this.events()
    this.makeSlideshow()
  }

  events()
  {
    for(let link of this.DOM.links)
    {
      const ease = 'cubic.out';
      const visual = link.querySelector('.fxVisual')
      link.addEventListener('mouseenter',()=>{
        gsap.to(
          visual,
          {
            scale:1.08,
            ease:ease,
            duration:.7,
          }
        )
      })
      link.addEventListener('mouseleave',()=>{
        gsap.killTweensOf(this.DOM.visual)
        gsap.to(
          visual,
          {
            scale:1.01,
            ease:ease,
            duration:.7,
          }
        )
      })
    }
  }

  makeSlideshow()
  {
    this.slideshow = new Splide(this.DOM.view , {
      arrows: true,
      interval: 7000,
      padding:{ left:70, right:70 },
      pauseOnFocus:false,
      pauseOnHover:false,
      pagination:false,
      perPage:3,
      perMove:1,
      rewind:true,
      rewindByDrag:true,
      speed: 700,
      type: 'slide',
      arrowPath:'M1 1L9 9L1 17',
      breakpoints: {
        640: {
          padding:{ left:24, right:24 },
          perPage:1
        }
      },
    }).mount();
  }

  unmount()
  {

  }
}
